<template>
<div>
  
  <h4  :style="{ color: localTextColor }" v-if="doc.documentId">
    <i  class="fas fa-store mr-2" aria-hidden="true"></i>
    {{doc.store}}   -   
    
       {{doc.supplier}}  -  COLLEZIONE  {{ doc.collection_description }}    - 
       <i class="fas fa-file-alt mr-2" aria-hidden="true"></i>
       {{doc.description}}   n.ro  {{doc.number}}   del  
     {{doc.date }}
       
       
  </h4>
  <h4  v-else> {{item.store}} - {{item.name}} -  {{item.typeId == 1 ? 'FATTURA':'DDT' }} n.ro {{item.number}} del  
        {{
       new Date(item.date).toLocaleDateString('it-IT',{ year: 'numeric', month: '2-digit', day: '2-digit' })
       }}
        
  </h4>      

</div>
</template>
<script>

//import api                 from '@/api';

export default {
   

  props  : ['doc','item','textColor'],
  data () 
  {
    return {
       
       localTextColor : 'black'  
       
      // textColor : "white" 

    }
    
    },

  mounted()
  {
      if(this.textColor)
      {
        this.localTextColor = this.textColor
      }
      
  },

  methods: {

    
  }
}
</script>

<style scoped>
 h4 {
  font-family : 'Roboto Condensed';
  font-size   : 26px;
 
   }
</style>
